// @ts-nocheck
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, Paper, Box, Typography } from '@material-ui/core';
import { StringUtils } from '../utils';

const useStyles = makeStyles(theme => ({
  normalContainer: {
    position: 'relative',
    minWidth: '500px',
    marginTop: theme.spacing(3),
    padding: theme.spacing(10, 3, 3, 3),
  },
  normalHeader: {
    position: 'absolute',
    top: theme.spacing(-3),
    left: theme.spacing(3),
    right: theme.spacing(3),
    padding: theme.spacing(3),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    cursor: 'default',
  },
  containedContainer: {
    height: '100%',
    overflow: 'hidden',
  },
  containedHeader: {
    height: '3px',
    backgroundColor: theme.palette.primary.main,
  },
  containedTitle: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(3),
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
}));

function Panel(props) {
  const classes = useStyles();

  const { id, className, title, variant, children } = props;

  if (variant === 'contained') {
    return (
      <Paper id={id} className={clsx(classes.containedContainer, className)}>
        <Box id={StringUtils.makeId(id, 'header')} className={classes.containedHeader} />
        {title && (
          <Typography
            id={StringUtils.makeId(id, 'title')}
            className={classes.containedTitle}
            variant="h6"
            noWrap
          >
            {title}
          </Typography>
        )}
        <Box id={StringUtils.makeId(id, 'content')} className={classes.content}>
          {children}
        </Box>
      </Paper>
    );
  }

  return (
    <Paper id={id} className={clsx(classes.normalContainer, className)}>
      <Paper id={StringUtils.makeId(id, 'header')} className={classes.normalHeader} elevation={5}>
        <Typography id={StringUtils.makeId(id, 'title')} variant="h6" noWrap>
          {title}
        </Typography>
      </Paper>
      <Box id={StringUtils.makeId(id, 'content')} className={classes.content}>
        {children}
      </Box>
    </Paper>
  );
}

Panel.defaultProps = {
  id: undefined,
  children: undefined,
  className: undefined,
  title: undefined,
  variant: 'normal',
};

Panel.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.node,
  variant: PropTypes.oneOf(['normal', 'contained']),
};

export default Panel;
